import './style.css';
import logoNegro from '../../img/logo.png';
import iconBusqueda from '../../img/lupaNegra.png';
import logoMoradoDegradado from '../../img/logoDegradadoMorado.png';

function Busqueda(props) {
    return ( 
        <div className={`busqueda ${props.showBusqueda ? "busqueda-visible modoBusqueda" : "busqueda-hidden"}`}>
            <img src={logoMoradoDegradado} alt="" className='fondoBusqueda'/>
            <div className="row rowLogo">
                <div className="col-4 col-sm-3 col-md-2 col-lg-1 m-0 p-0 d-flex">
                    <img src={logoNegro} alt="" width={'70%'} className='mb-0 mt-auto'/>
                </div>
                <div className="col-8 col-sm-9 col-md-10 col-lg-11"></div>
            </div>            
            <div className="row rowBusqueda" onClick={() => props.showBusqueda === false && props.setShowBusqueda(true)}>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <img src={iconBusqueda} alt="" className='iconBusqueda'/>
                    </div>
                    <input type="text" className="form-control" placeholder={`${props.showBusqueda ? 'Buscar' : '2D'}`} aria-label="Username" aria-describedby="basic-addon1" readOnly={!props.showBusqueda}/>
                </div>
            </div>
            {props.showBusqueda && (
                <div className="containerBusqueda animate__animated animate__fadeIn">
                    <div className="sugerenciasBusqueda">
                    {['3D', '2D', 'Motion Graphics', 'Fooh', 'CGI', 'Producto'].map((tag) => (
                        <button key={tag} className="etiqueta">{tag}</button>
                    ))}
                    </div>
                </div>
            )}
        </div>
     );
}

export default Busqueda;